export default "__VITE_ASSET__ifsZTOyh__"